"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _components = require("@engaging-tech/components");

/**
 * A clickable button with the icon for the specified social media
 * network. When clicked, the button opens the profile in a new tab.
 * @param {object} network A social media network name & profile
 * URL.
 */
var SocialMediaIcon = function SocialMediaIcon(_ref) {
  var network = _ref.network;
  return /*#__PURE__*/_react["default"].createElement("a", {
    href: network.url,
    target: "_blank noopener noreferrer"
  }, /*#__PURE__*/_react["default"].createElement(_components.Flex, {
    borderRadius: 99,
    width: ["40px", "40px", "32px"],
    height: ["40px", "40px", "32px"],
    bg: "dark.6",
    alignItems: "center",
    justifyContent: "center",
    mx: 2
  }, /*#__PURE__*/_react["default"].createElement(_components.Icon, {
    size: "16px",
    name: network.name
  })));
};
/**
 * Renders social media links.
 * @param {array} networks A list of social media network names
 * and profile URLs.
 * @package
 */


var SocialMediaIcons = function SocialMediaIcons(_ref2) {
  var networks = _ref2.networks;
  return networks.map(function (network) {
    return /*#__PURE__*/_react["default"].createElement(SocialMediaIcon, {
      key: network.name,
      network: network
    });
  });
};

var _default = SocialMediaIcons;
exports["default"] = _default;